import {
  APP_INIT,
  APP_LAYOUT_CHANGE,
  DECREMENT_REQUEST_COUNTER,
  INCREMENT_REQUEST_COUNTER,
  POP_SNACKBAR,
  PUSH_SNACKBAR,
  RESET_REQUEST_COUNTER,
} from 'FRONTEND/actions/constants';

const initialState = {
  requestCounter: {},
  isLoading: false,
  snackbars: [],
  browserSupport: null,
  isInit: false,
  isSmall: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case APP_INIT: {
      return {
        ...state,
        browserSupport: action.payload.browserSupport,
        isInit: true,
      };
    }

    case INCREMENT_REQUEST_COUNTER: {
      const newState = {
        ...state,
        requestCounter: {
          ...state.requestCounter,
          [action.payload.type]: true,
        },
      };

      return {
        ...newState,
        isLoading: Object.values(newState.requestCounter).find((counter) => counter) || false,
      };
    }

    case DECREMENT_REQUEST_COUNTER: {
      const newState = {
        ...state,
        requestCounter: {
          ...state.requestCounter,
          [action.payload.type]: false,
        },
      };

      return {
        ...newState,
        isLoading: Object.values(newState.requestCounter).find((counter) => counter) || false,
      };
    }

    case RESET_REQUEST_COUNTER: {
      const requestCounter = Object.keys(state.requestCounter).reduce((acc, requestKey) => {
        acc[requestKey] = false;
        return acc;
      }, {});

      return {
        ...state,
        requestCounter,
        isLoading: false,
      };
    }

    case PUSH_SNACKBAR: {
      const newSnackbars = [...state.snackbars, {
        message: action.payload.message,
        variant: action.payload.variant,
        link: action.payload.link,
        autoHideDuration: action.payload.autoHideDuration,
      }];
      return {
        ...state,
        snackbars: newSnackbars,
      };
    }

    case POP_SNACKBAR: {
      const newSnackbars = state.snackbars.slice(1);

      return {
        ...state,
        snackbars: newSnackbars,
      };
    }

    case APP_LAYOUT_CHANGE: {
      return {
        ...state,
        isSmall: action.payload.isSmall,
      };
    }

    default:
      return state;
  }
};
